import { render, staticRenderFns } from "./ItemData.vue?vue&type=template&id=761b5dd7&scoped=true&"
import script from "./ItemData.vue?vue&type=script&lang=js&"
export * from "./ItemData.vue?vue&type=script&lang=js&"
import style0 from "./ItemData.vue?vue&type=style&index=0&id=761b5dd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761b5dd7",
  null
  
)

export default component.exports